import { Box, CardContent, CardHeader, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import ReliabilityReport from 'components/../../cypress/fixtures/v1/policies/906a6e2a-844c-46f1-a8cd-8ac29685cf4d/reliability-report/GET_reliability_report_with_all_policy_categories.json'
import Icon from 'components/Icon'
import ReliabilityScoreDetails from 'components/services/details/ReliabilityScoreDetails'
import { useTranslation } from 'hooks/use-translation'
import theme from 'theme'
import { CategoryScores } from 'types/api/policies/reliability-report'

export const HowReliabilityIsMeasured: React.FC = () => {
  const { trans } = useTranslation()

  return (
    <>
      <CardHeader
        title={
          <Typography variant="h6">
            {trans('getting_started.how_reliability_is_measured.title')}{' '}
            <Link
              target="_blank"
              to="https://www.gremlin.com/blog/how-gremlins-reliability-score-works/"
            >
              <Icon
                css={{ fontSize: theme.fontSizes[2] }}
                icon="arrowUpRightFromSquare"
              />
            </Link>
          </Typography>
        }
      />
      <CardContent>
        <Typography variant="body2">
          {trans('getting_started.how_reliability_is_measured.paragraph')}
        </Typography>
        <Box py={2}>
          <ReliabilityScoreDetails
            scores={ReliabilityReport.categoryScores as CategoryScores}
          />
        </Box>
      </CardContent>
    </>
  )
}
